import { render, staticRenderFns } from "./iosGw.vue?vue&type=template&id=1513544f&scoped=true&"
import script from "./iosGw.vue?vue&type=script&lang=js&"
export * from "./iosGw.vue?vue&type=script&lang=js&"
import style0 from "./iosGw.vue?vue&type=style&index=0&id=1513544f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513544f",
  null
  
)

export default component.exports